/* pdp-customily-overrides.js — LIVE-parity Preview trigger and modal ATC adapter. */
(function () {
  'use strict';

  var optionRenderPending = false;
  var renderStateTimer = null;
  var pendingPreviewTrigger = null;
  var pendingPreviewTimer = null;
  var previewRequestPending = false;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function dispatchPreview(trigger) {
    pendingPreviewTrigger = null;
    clearTimeout(pendingPreviewTimer);
    window.dispatchEvent(new CustomEvent('customily-preview-modal-show'));
    waitForPreviewModal(trigger);
  }

  function setPreviewLoading(trigger, on) {
    trigger.classList.toggle('running', on);
    if (on) trigger.setAttribute('aria-busy', 'true');
    else trigger.removeAttribute('aria-busy');
  }

  function requestPreview(trigger) {
    if (previewRequestPending) return;
    previewRequestPending = true;
    setPreviewLoading(trigger, true);
    if (!optionRenderPending) {
      dispatchPreview(trigger);
      return;
    }
    pendingPreviewTrigger = trigger;
    clearTimeout(pendingPreviewTimer);
    pendingPreviewTimer = setTimeout(function () {
      dispatchPreview(trigger);
    }, 500);
  }

  window.addEventListener('customily-options-changed', function () {
    optionRenderPending = true;
    clearTimeout(renderStateTimer);
    renderStateTimer = setTimeout(function () {
      optionRenderPending = false;
    }, 1000);
  });

  window.addEventListener('customily-canvas-rendered', function () {
    optionRenderPending = false;
    clearTimeout(renderStateTimer);
    if (pendingPreviewTrigger) dispatchPreview(pendingPreviewTrigger);
  });

  /* Keep Customily's SDK button hidden and render the themed trigger
   * `.preview_btn` immediately before quantity + ATC. Shrine previously hid
   * the SDK button without replacing that visible trigger, leaving customers
   * with no way to open the preview modal. Create the LIVE trigger once the
   * SDK button mounts, then dispatch the same SDK modal event. */
  function ensurePreviewTrigger() {
    if (document.querySelector('.sc-customily-preview-trigger')) return true;
    var sdkButton = document.getElementById('customily-preview-button');
    if (!sdkButton || !sdkButton.parentNode) return false;

    var trigger = document.createElement('div');
    trigger.className = 'preview_btn sc-customily-preview-trigger';
    trigger.classList.add('ld-over-inverse');
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.textContent = 'Preview';
    function openPreview() {
      var gate = new CustomEvent('sc-customily-before-preview', {
        bubbles: true,
        cancelable: true
      });
      if (!trigger.dispatchEvent(gate)) return;
      /* Customily's own preview-button handler only dispatches this event.
       * A native button inside Shrine's product form enters the delegated
       * required-field pipeline before its target listener runs. LIVE uses a
       * `.preview_btn` div, so match that boundary and dispatch the SDK event
       * directly after the shared required-field guard passes. */
      requestPreview(trigger);
    }
    trigger.addEventListener('click', openPreview);
    trigger.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      openPreview();
    });
    sdkButton.parentNode.insertBefore(trigger, sdkButton);
    return true;
  }

  function initPreviewTrigger() {
    if (ensurePreviewTrigger()) return;
    var poll = setInterval(function () {
      if (ensurePreviewTrigger()) clearInterval(poll);
    }, 300);
    setTimeout(function () { clearInterval(poll); }, 30000);
  }

  if (document.readyState !== 'loading') initPreviewTrigger();
  else document.addEventListener('DOMContentLoaded', initPreviewTrigger);

  /* LIVE reference uses a compact select while Shrine owns a native quantity
   * input. Keep the native input as the only named/form-associated control and
   * synchronize this visible facade to it so Shopify quantity rules and cart
   * payloads continue through the existing product-form contract. */
  function positiveInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function ensureQuantitySelect() {
    var realAtc = document.getElementById('customily-cart-btn');
    var controls = realAtc && realAtc.closest('.product-form__quantity-and-btn');
    var wrapper = controls && controls.querySelector(':scope > .product-form__quantity');
    var nativeInput = wrapper && wrapper.querySelector('quantity-input .quantity__input[name="quantity"]');
    if (!wrapper || !nativeInput) return false;

    var existing = wrapper.querySelector('.sc-customily-quantity-select');
    if (existing
        && existing.scNativeQuantityInput === nativeInput
        && typeof existing.scSyncFromNative === 'function') {
      existing.scSyncFromNative();
      return true;
    }
    if (existing) existing.remove();
    var existingLabel = wrapper.querySelector('.sc-customily-quantity-label');
    if (existingLabel) existingLabel.remove();

    var select = document.createElement('select');
    select.className = 'sc-customily-quantity-select';
    select.id = (nativeInput.id || 'Quantity') + '-select';
    select.scNativeQuantityInput = nativeInput;

    var label = document.createElement('label');
    label.className = 'sc-customily-quantity-label';
    label.htmlFor = select.id;
    label.textContent = 'Quantity';

    function appendOption(value, text) {
      var option = document.createElement('option');
      option.value = String(value);
      option.textContent = text;
      select.appendChild(option);
    }

    function rebuildOptions() {
      var min = positiveInteger(nativeInput.getAttribute('min') || nativeInput.dataset.min, 1);
      var step = positiveInteger(nativeInput.getAttribute('step'), 1);
      var maxValue = nativeInput.getAttribute('max') || nativeInput.dataset.max;
      var max = maxValue ? positiveInteger(maxValue, null) : null;
      var current = positiveInteger(nativeInput.value, min);
      var signature = [min, step, max, current, nativeInput.disabled ? 1 : 0].join('|');
      if (select.scQuantitySignature === signature) return;
      select.scQuantitySignature = signature;
      select.textContent = '';
      for (var i = 0; i <= 10; i += 1) {
        var value = min + (i * step);
        if (max !== null && value > max) break;
        appendOption(value, i === 10 ? String(value - step) + '+' : String(value));
      }

      var hasCurrent = Array.prototype.some.call(select.options, function (option) {
        return option.value === String(current);
      });
      if (!hasCurrent) appendOption(current, String(current));
      select.value = String(current);
      select.disabled = Boolean(nativeInput.disabled);
      if (select.disabled) select.setAttribute('aria-disabled', 'true');
      else select.removeAttribute('aria-disabled');
    }

    function syncFromNative() {
      rebuildOptions();
    }

    select.scSyncFromNative = syncFromNative;
    select.addEventListener('change', function () {
      nativeInput.value = select.value;
      nativeInput.dispatchEvent(new Event('input', { bubbles: true }));
      nativeInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    nativeInput.addEventListener('input', syncFromNative);
    nativeInput.addEventListener('change', syncFromNative);

    rebuildOptions();
    wrapper.appendChild(label);
    wrapper.appendChild(select);
    wrapper.classList.add('sc-customily-quantity-select-ready');
    controls.classList.add('sc-customily-controls-ready');
    return true;
  }

  function initQuantitySelect() {
    if (ensureQuantitySelect()) {
      ensureControlsObserver();
      return;
    }
    var poll = setInterval(function () {
      if (ensureQuantitySelect()) {
        ensureControlsObserver();
        clearInterval(poll);
      }
    }, 300);
    setTimeout(function () { clearInterval(poll); }, 30000);
  }

  if (document.readyState !== 'loading') initQuantitySelect();
  else document.addEventListener('DOMContentLoaded', initQuantitySelect);
  ['variant:change', 'on:variant:change'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      setTimeout(function () {
        ensurePreviewTrigger();
        ensureQuantitySelect();
        ensureControlsObserver();
      }, 0);
    });
  });

  /* Shopify sections and Customily can replace the SDK/quantity subtree after
   * the initial polls have stopped. Observe only the owning product runtime;
   * ignore mutations created by our own select options to prevent feedback. */
  function ensureControlsObserver() {
    var realAtc = document.getElementById('customily-cart-btn');
    var owner = realAtc && (realAtc.closest('product-info') || realAtc.closest('.main-product-section'));
    if (!owner || owner.scCustomilyControlsObserver) return Boolean(owner);

    var scheduled = null;
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        var target = mutation.target;
        return !target.closest
          || !target.closest('.sc-customily-quantity-select, .sc-customily-quantity-label');
      });
      if (!relevant) return;
      clearTimeout(scheduled);
      scheduled = setTimeout(function () {
        ensurePreviewTrigger();
        ensureQuantitySelect();
      }, 0);
    });
    observer.observe(owner, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['min', 'max', 'step', 'value', 'disabled', 'data-min', 'data-max']
    });
    owner.scCustomilyControlsObserver = observer;
    return true;
  }

  document.addEventListener('shopify:section:load', function () {
    initPreviewTrigger();
    initQuantitySelect();
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var owner = event.target && event.target.querySelector
      ? event.target.querySelector('product-info, .main-product-section')
      : null;
    if (!owner || !owner.scCustomilyControlsObserver) return;
    owner.scCustomilyControlsObserver.disconnect();
    delete owner.scCustomilyControlsObserver;
  });

  /* --------------------------------------------------------------------------
   * Modal ATC clone — direct port of LIVE theme behavior (app.js.liquid:4396-4404).
   * Clone the visible product-form ATC (#customily-cart-btn) into the Customily
   * preview modal so styling matches the on-page button exactly. Rename clone to
   * #preview-cart-btn; forward clicks to the real ATC. */
  function injectModalAtc() {
    var main = document.querySelector('.customily-modal-preview-only .main');
    if (!main) return false;
    if (main.querySelector('#preview-cart-btn')) return true;
    var realAtc = document.getElementById('customily-cart-btn');
    if (!realAtc) return false;
    var clone = realAtc.cloneNode(true);
    clone.id = 'preview-cart-btn';
    clone.removeAttribute('name');
    clone.type = 'button';
    /* The on-page Customily ATC has no cart glyph and inherits uppercase copy.
     * The Preview modal intentionally follows CustomAll's action contract, so
     * add CustomAll's exact 21px cart-plus SVG and normalize only the cloned
     * label. Keep the remaining cloned children (errors/spinners) untouched. */
    var label = clone.querySelector('.main-atc__label__text') ||
      clone.querySelector('.main-atc__label') ||
      clone.querySelector('.button__label');
    if (label) label.textContent = 'Add to cart';
    clone.insertAdjacentHTML('afterbegin',
      '<svg class="sc-preview-cart-icon" aria-hidden="true" focusable="false" ' +
        'xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">' +
        '<path d="M1 1L3.07568 1.36L5.03459 12.833C5.11143 13.77 5.89281 14.489 6.83085 14.486H15.7213C16.6165 14.488 17.3759 13.828 17.5026 12.94L19.4476 6.382" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
        '<path d="M7.98535 6.5H14.9708" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
        '<path d="M11.4783 3L11.4783 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M6.39297 17.9525C6.69334 17.9525 6.93584 18.1965 6.93584 18.4965C6.93584 18.7975 6.69334 19.0415 6.39297 19.0415C6.09259 19.0415 5.8501 18.7975 5.8501 18.4965C5.8501 18.1965 6.09259 17.9525 6.39297 17.9525Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M15.6542 17.9525C15.9546 17.9525 16.1981 18.1965 16.1981 18.4965C16.1981 18.7975 15.9546 19.0415 15.6542 19.0415C15.3538 19.0415 15.1113 18.7975 15.1113 18.4965C15.1113 18.1965 15.3538 17.9525 15.6542 17.9525Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg>');
    /* Match native Shrine ATC loading indicator: real button uses loading.io
     * `.ld-over-inverse` + `.running` (overlay spinner over button). Cloned
     * button inherits `ld-over-inverse` class via cloneNode — just toggle
     * `.running` to activate the same overlay. This is identical to how the
     * real ATC behaves during form submit (Shrine form-handler.js adds
     * `.running` then removes on response). */
    function setLoading(on) {
      clone.classList.toggle('running', on);
      clone.disabled = on;
      if (on) clone.setAttribute('aria-busy', 'true');
      else clone.removeAttribute('aria-busy');
    }
    clone.addEventListener('click', function (e) {
      e.preventDefault();
      if (clone.disabled) return;
      setLoading(true);
      var checkResponse = waitForCartResponse(function (result) {
        setLoading(false);
        if (result === 'success') {
          var closeBtn = document.querySelector('.customily-modal-preview-only .customily-close-button');
          if (closeBtn) closeBtn.click();
        } else if (result === 'invalid') {
          revealFirstInvalidOption();
        }
      });
      /* Observe cart success/error before submitting so synchronous Customily
       * validation cannot finish before the listener is attached. */
      realAtc.click();
      checkResponse();
    });
    main.appendChild(clone);
    return true;
  }

  /* Hide spinner when cart submit completes. Shrine's cart-notification.js adds
   * `.active` on #cart-notification on success; cart-drawer similarly toggles
   * `.active`. Watch both + product-form error message + safety timeout. */
  function findVisibleRequiredRow() {
    /* Customily can portal the option list outside #cl_optionsapp, so search
     * the rendered labels globally and return their owning option row. */
    var labels = document.querySelectorAll('.customily-required-label span');
    for (var i = 0; i < labels.length; i++) {
      var row = labels[i].closest('.customily_option');
      if (row && labels[i].getClientRects().length) return row;
    }
    return null;
  }

  function revealFirstInvalidOption() {
    var row = findVisibleRequiredRow();
    if (!row) return;
    var closeBtn = document.querySelector('.customily-modal-preview-only .customily-close-button');
    if (closeBtn) closeBtn.click();
    requestAnimationFrame(function () {
      row.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
      var control = row.querySelector('input:not([type=hidden]), textarea, select, [tabindex], [role="button"]') || row;
      if (!control.hasAttribute('tabindex') && !/^(INPUT|TEXTAREA|SELECT)$/.test(control.tagName)) {
        control.setAttribute('tabindex', '-1');
      }
      if (control.focus) control.focus({ preventScroll: true });
    });
  }

  function waitForCartResponse(done) {
    var finished = false;
    function finish(result) {
      if (finished) return;
      finished = true;
      obs.disconnect();
      clearInterval(poll);
      clearTimeout(timer);
      done(result);
    }
    function checkResponse() {
      if (findVisibleRequiredRow()) {
        finish('invalid');
        return;
      }
      for (var i = 0; i < targets.length; i++) {
        var t = targets[i];
        if (t.classList.contains('active')) {
          finish('success');
          return;
        }
        if (t.matches && t.matches('.product-form__error-message-wrapper') && !t.hasAttribute('hidden')) {
          /* Keep the Preview open for Shopify/network errors so its context is
           * not mistaken for a Customily required-field failure. */
          finish('error');
          return;
        }
      }
    }
    var targets = [
      document.getElementById('cart-notification'),
      document.querySelector('cart-drawer'),
      document.querySelector('.product-form__error-message-wrapper')
    ].filter(Boolean);
    var requiredLabels = Array.prototype.slice.call(
      document.querySelectorAll('.customily-required-label span')
    );
    var obs = new MutationObserver(function () {
      checkResponse();
    });
    targets.forEach(function (t) {
      obs.observe(t, { attributes: true, attributeFilter: ['class', 'hidden'] });
    });
    requiredLabels.forEach(function (label) {
      obs.observe(label, { attributes: true, attributeFilter: ['class', 'style'] });
    });
    /* Customily may replace the required-label nodes during validation, which
     * detaches per-node observers. A short-lived poll covers that portal
     * re-render without a permanent body-wide observer. */
    var poll = setInterval(checkResponse, 50);
    var timer = setTimeout(function () { finish('timeout'); }, 8000);
    return checkResponse;
  }

  function waitForPreviewModal(trigger) {
    var tries = 0;
    var poll = setInterval(function () {
      var modal = document.querySelector('.customily-modal-preview-only');
      var visible = modal && getComputedStyle(modal).display !== 'none';
      var atcReady = injectModalAtc();
      if ((visible && atcReady) || ++tries > 80) {
        previewRequestPending = false;
        if (trigger) setPreviewLoading(trigger, false);
        clearInterval(poll);
      }
    }, 100);
  }

  /* Customily SDK renders the modal async after `.customily-preview-button`
   * click. Capture-phase click + short poll handles the render delay without
   * a permanent body-wide MutationObserver. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.customily-preview-button')) return;
    waitForPreviewModal(document.querySelector('.sc-customily-preview-trigger'));
  }, true);

})();
